import { faCheckCircle } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useMemo } from 'react'

import Header from '../../components/collections/Header'
import TagManager from '../../lib/tag-manager'

const onClickClose = () => {
    const isInClient = window.liff.isInClient()
    if (isInClient) {
        window.liff
            .sendMessages([
                {
                    type: 'text',
                    text: 'ท่านได้ยกเลิกการให้ความยินยอมเปิดเผยข้อมูลเพื่อวัตถุประสงค์ทางการตลาด (cross-sell) ของแอป Money Thunder เรียบร้อยแล้ว',
                },
            ])
            .then(() => {
                TagManager.popupEvent({
                    page: 'submitted-cross-sell',
                    action: 'send-message',
                    field: JSON.stringify({
                        isInClient,
                        status: 'success',
                    }),
                })
            })
            .catch((e) => {
                TagManager.popupEvent({
                    page: 'submitted-cross-sell',
                    action: 'send-message',
                    field: JSON.stringify({
                        isInClient,
                        status: 'failure',
                        errorCode: e.code,
                        message: e.message,
                    }),
                })
            })
            .finally(() => {
                window.liff.closeWindow()
            })
        window.liff.closeWindow()
    }
}

const SubmittedFormCrossSell: React.FC = () => {
    useMemo(() => {
        TagManager.loadEvent({ page: 'submitted-cross-sell' })
    }, [])

    return (
        <div className="submitted-form completed">
            <Header title="PDPA" cancelable={false} />
            <div className="container abcs-container">
                <FontAwesomeIcon
                    className="checked-with-circle-container"
                    icon={faCheckCircle}
                    size="4x"
                />
                <h6>ส่งข้อมูลเรียบร้อยแล้ว</h6>
                <div className="paragraph-content">
                    <p>
                        ท่านได้ยกเลิกการให้ความยินยอมเปิดเผยข้อมูลเพื่อวัตถุประสงค์ทางการตลาด
                        (cross-sell) ของแอป Money Thunder เรียบร้อยแล้ว
                    </p>
                </div>
            </div>
            <footer className="abcs-container">
                <button type="button" className="abcs-button primary fluid" onClick={onClickClose}>
                    ปิด
                </button>
            </footer>
        </div>
    )
}
export default SubmittedFormCrossSell
